import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import ScheduleDeactivateTeamsModal from './ScheduleDeactivateTeamsModal';

export const useScheduleDeactivateTeamsModal = () => {
  const { openModal } = useDynamicModal();

  const openScheduleDeactivateTeamsModal = useCallback(
    ({
      teamTargets,
      teamNamesById,
      onAfterSchedule,
    }: {
      teamTargets: Array<{ teamId: number; tenant: string; realmId: string }>;
      teamNamesById: Record<number, string>;
      onAfterSchedule?: VoidFunction;
    }) => {
      openModal({
        modal: ({ toggle }) => (
          <ScheduleDeactivateTeamsModal
            teamNamesById={teamNamesById}
            teamTargets={teamTargets}
            onClose={toggle}
            onAfterSchedule={onAfterSchedule}
          />
        ),
      });
    },
    [openModal],
  );

  return {
    openScheduleDeactivateTeamsModal,
  };
};

export default useScheduleDeactivateTeamsModal;
